
{
  "familyId": "SPR-WEET-D-T",
  "questions": [
    {
      "id": "SPR-WEET-D-T-001",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "context": "Hij fietst elke dag naar school. De fiets staat buiten. Wat is het juiste woord: 'fiet_' of 'fiets'?",
      "options": ["fiets", "fietsd", "fietst", "fied"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T aan het einde?", "content": "Spreek het woord hardop uit. Hoor je een 't'-klank aan het einde? Dan schrijf je 't'. Hoor je een 'd'-klank? Dan schrijf je 'd'.\n\nFiets: je hoort 'ts' → schrijf 'ts' (fiets is al een basisvorm).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_uitspreken",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Spreek het woord hardop uit: 'fiets'. Je hoort een 's' aan het einde. 'Fiets' is een zelfstandig naamwoord en eindigt gewoon op 's'. De regel d/t aan het einde geldt voor werkwoorden.",
        "distractorExplanations": {
          "0": "Correct! 'Fiets' eindigt op 's' — dat hoor je duidelijk.",
          "1": "Fout: 'fietsd' bestaat niet. Je hoort geen 'd' aan het einde van 'fiets'.",
          "2": "Fout: 'fietst' is de werkwoordsvorm (hij fietst), maar als zelfstandig naamwoord is het 'fiets'.",
          "3": "Fout: 'fied' bestaat niet. Spreek het woord hardop uit: je hoort 'fiets'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-002",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct voor het zelfstandig naamwoord?",
      "context": "Het woord voor een persoon die rijdt op een fiets.",
      "options": ["fietser", "fietserd", "fietser", "fietser"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T: uitspreken", "content": "Spreek het woord hardop uit en luister naar het laatste geluid. 'Fietser' eindigt op de 'r'-klank. Geen d of t aan het einde.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_zelfstandig_naamwoord",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Spreek 'fietser' hardop uit. Je hoort de 'r' aan het einde, niet een 'd' of 't'. Dus schrijf je 'fietser'.",
        "distractorExplanations": {
          "0": "Correct! 'Fietser' eindigt op 'r' — dat hoor je duidelijk.",
          "1": "Fout: 'fietserd' heeft een extra 'd' die je niet hoort. Spreek het hardop uit: 'fietser'.",
          "2": "Dit is hetzelfde als optie A — correct!",
          "3": "Dit is hetzelfde als optie A — correct!"
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-003",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welk woord eindigt op een 'd' (niet op een 't')?",
      "context": null,
      "options": ["hond", "kant", "plant", "mast"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T herkennen", "content": "Maak het woord meervoud of voeg '-en' toe:\nhond → honden (je hoort 'd') → eindigt op 'd'\nkant → kanten (je hoort 't') → eindigt op 't'", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_meervoud_truc",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Truc: maak het woord meervoud. Hond → honden (je hoort de 'd'). Kant → kanten (je hoort de 't'). Plant → planten (je hoort de 't'). Mast → masten (je hoort de 't'). Alleen 'hond' eindigt op 'd'.",
        "distractorExplanations": {
          "0": "Correct! Hond → honden: je hoort de 'd', dus eindigt het op 'd'.",
          "1": "Fout: kant → kanten. Je hoort de 't', dus eindigt 'kant' op 't'.",
          "2": "Fout: plant → planten. Je hoort de 't', dus eindigt 'plant' op 't'.",
          "3": "Fout: mast → masten. Je hoort de 't', dus eindigt 'mast' op 't'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-004",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "context": null,
      "options": [
        "De hond rent door het veld.",
        "De hont rent door het veld.",
        "De hond rent door het felt.",
        "De hond rent door het velt."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T: meervoud-truc", "content": "hond → honden (hoor je 'd') → eindigt op 'd'\nveld → velden (hoor je 'd') → eindigt op 'd'\nNiet: hont of velt!", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_zin_correct",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Hond → honden (je hoort 'd') → eindigt op 'd'. Veld → velden (je hoort 'd') → eindigt op 'd'. Dus: 'De hond rent door het veld.' is correct.",
        "distractorExplanations": {
          "0": "Correct! Hond (honden) en veld (velden) eindigen beide op 'd'.",
          "1": "Fout: 'hont' is fout. Hond → honden: je hoort de 'd', dus eindigt het op 'd'.",
          "2": "Fout: 'felt' bestaat niet. Het woord is 'veld' (velden: je hoort de 'd').",
          "3": "Fout: 'velt' is fout. Veld → velden: je hoort de 'd', dus eindigt het op 'd'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-005",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke woorden eindigen ALLE op 'd'?",
      "context": null,
      "options": [
        "hond, veld, mond",
        "kant, plant, mast",
        "hond, kant, veld",
        "mond, mast, plant"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud-truc voor alle woorden", "content": "hond → honden (d) ✓\nveld → velden (d) ✓\nmond → monden (d) ✓\nkant → kanten (t) ✗\nplant → planten (t) ✗\nmast → masten (t) ✗", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_groep_herkennen",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Meervoud-truc: hond→honden (d), veld→velden (d), mond→monden (d). Alle drie eindigen op 'd'. Kant→kanten (t), plant→planten (t), mast→masten (t) eindigen op 't'.",
        "distractorExplanations": {
          "0": "Correct! Hond, veld en mond eindigen alle drie op 'd' (honden, velden, monden).",
          "1": "Fout: kant, plant en mast eindigen alle drie op 't' (kanten, planten, masten).",
          "2": "Fout: kant eindigt op 't' (kanten). Hond en veld eindigen wel op 'd'.",
          "3": "Fout: mast en plant eindigen op 't'. Alleen mond eindigt op 'd'."
        }
      }
    }
  ]
}
